const setHeaderColor = () => {
    const header = document.querySelector('header');
    const headerMain = document.querySelector('.main-header');
    if (!header) return;

    const headerHeight = header.offsetHeight;

    const onScroll = () => {
        if (window.scrollY > headerHeight) {
            headerMain.classList.add('scrolled');
        } else {
            headerMain.classList.remove('scrolled');
        }
    };

    // Run once on load in case you're already scrolled
    window.addEventListener('load', onScroll);
    // Then update on every scroll
    window.addEventListener('scroll', onScroll);
};

export default setHeaderColor;
